module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0723-min.dea3f65b.jpg";